module.exports = __webpack_public_path__ + "static/uber-faaa0c90ecfa5f8f74d22ed934b7a0c1.png";